<template>
  <head>
    <meta charset="utf-8"/>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.png" rel="shortcut icon">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
          rel="stylesheet">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Imprest Approval</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Imprest</a></li>
                    <li class="breadcrumb-item active">Approval</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Imprest Approval Stats -->
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Requests</p>
                      <h5 class="mb-0">{{ totalRequests }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="mdi mdi-file-document"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Pending Approval</p>
                      <h5 class="mb-0">{{ pendingApprovals }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="mdi mdi-clock"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Amount</p>
                      <h5 class="mb-0">{{ formatPrice(totalPendingAmount) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="mdi mdi-cash"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Added New Card for Average Request Amount -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Average Amount</p>
                      <h5 class="mb-0">{{ formatPrice(totalPendingAmount / (pendingApprovals || 1)) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="mdi mdi-chart-line"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Imprest Approval Table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center flex-wrap">
                  <h5 class="card-title mb-md-0">Imprest Requests Pending Approval</h5>

                  <!-- Add this right next to your search box in the card header -->
                  <div class="d-flex gap-2 flex-wrap mt-3 mt-md-0">
                    <div class="search-box mb-2 mb-md-0">
                      <div class="position-relative">
                        <input
                            type="text"
                            class="form-control bg-light border-light rounded"
                            v-model="search"
                            placeholder="Search..."
                        >
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>

                    <div class="date-filter d-flex gap-2 flex-wrap">
                      <div class="form-group mb-2 mb-md-0">
                        <input
                            type="date"
                            class="form-control bg-light border-light rounded"
                            v-model="startDate"
                            placeholder="Start Date"
                        >
                      </div>
                      <div class="form-group mb-2 mb-md-0">
                        <input
                            type="date"
                            class="form-control bg-light border-light rounded"
                            v-model="endDate"
                            placeholder="End Date"
                        >
                      </div>
                      <button
                          class="btn btn-primary d-flex align-items-center gap-1"
                          @click="getImprestRequests()"
                          :disabled="isLoading"
                      >
                        <i class="bx bx-filter-alt"></i> Filter
                        <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <!-- Loading Skeleton -->
                  <div v-if="isLoading" class="table-responsive">
                    <div class="text-center p-4">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-2 text-muted">Loading imprest requests...</p>
                    </div>
                    <table class="table table-hover table-striped align-middle skeleton-loader">
                      <thead class="table-light">
                      <tr>
                        <th>Request ID</th>
                        <th>Purpose</th>
                        <th>Request By</th>
                        <th>Department</th>
                        <th>Amount (KES)</th>
                        <th>Requested Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="n in 5" :key="n">
                        <td><div class="skeleton-line"></div></td>
                        <td><div class="skeleton-line"></div></td>
                        <td><div class="skeleton-line"></div></td>
                        <td><div class="skeleton-line"></div></td>
                        <td><div class="skeleton-line"></div></td>
                        <td><div class="skeleton-line"></div></td>
                        <td><div class="skeleton-line"></div></td>
                        <td><div class="skeleton-line"></div></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Actual Table Data -->
                  <div v-else class="table-responsive">
                    <div v-if="imprestRequests.length === 0" class="text-center py-5">
                      <div class="avatar-sm mx-auto mb-3">
                        <div class="avatar-title bg-light text-primary rounded-circle font-size-24">
                          <i class="mdi mdi-file-search-outline"></i>
                        </div>
                      </div>
                      <h4 class="mt-3">No imprest requests found</h4>
                      <p class="text-muted">Try changing your search or filter criteria</p>
                    </div>

                    <table v-else class="table table-hover table-striped align-middle">
                      <thead class="table-light">
                      <tr>
                        <th>Request ID</th>
                        <th>Purpose</th>
                        <th>Request By</th>
                        <th>Department</th>
                        <th>Amount (KES)</th>
                        <th>Requested Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="request in imprestRequests" :key="request.request_id">
                        <td>{{ request.request_id}}</td>
                        <td>
                          <div class="text-wrap" style="max-width: 200px;">
                            {{ request.purpose }}
                          </div>
                        </td>
                        <td>{{ request.names }}</td>
                        <td>{{ request.department }}</td>
                        <td>{{ formatPrice(request.amount) }}</td>
                        <td>{{ formatDate(request.requestedDate) }}</td>
                        <td>
                          <span
                              :class="getStatusBadgeClass(request.status)"
                          >
                            {{ request.status }}
                          </span>
                        </td>
                        <td>
                          <div class="btn-group">
                            <button :disabled="request.status.toLowerCase() !== 'pending'"
                                    @click="approveRequest(request)"
                                    class="btn btn-success btn-sm"
                            >
                              <i class="mdi mdi-check-bold me-1"></i> Approve
                            </button>
                            <button :disabled="request.status.toLowerCase() !== 'pending'"
                                    @click="rejectRequest(request)"
                                    class="btn btn-danger btn-sm"
                            >
                              <i class="mdi mdi-close-thick me-1"></i> Reject
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Added pagination component -->
                <div class="card-footer bg-white d-flex justify-content-between align-items-center">
                  <div class="text-muted">
                    Showing <span class="fw-medium">{{ imprestRequests.length }}</span> of {{ totalRequests }} entries
                  </div>
                  <nav v-if="totalPages > 1">
                    <ul class="pagination pagination-rounded mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <button class="page-link" @click="changePage(currentPage - 1)">
                          <i class="mdi mdi-chevron-left"></i>
                        </button>
                      </li>
                      <li v-for="page in displayPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <button class="page-link" @click="changePage(currentPage + 1)">
                          <i class="mdi mdi-chevron-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- Action confirmation modal -->
  <div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmationModalLabel">{{ modalTitle }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          {{ modalMessage }}
          <div v-if="modalAction === 'reject'" class="mt-3">
            <label for="rejectionReason" class="form-label">Reason for rejection</label>
            <textarea id="rejectionReason" class="form-control" v-model="rejectionReason" rows="3" placeholder="Please provide a reason for rejecting this request"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button type="button" :class="modalAction === 'approve' ? 'btn btn-success' : 'btn btn-danger'" @click="confirmAction">
            {{ modalAction === 'approve' ? 'Approve' : 'Reject' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import {authUrl, execute} from "@/api";
import moment from "moment";
import NavigationBar from "@/components/Navigation.vue";

export default {
  name: 'ImprestApproval',
  components: {NavigationBar},
  data() {
    return {
      search: '',
      startDate: '',
      endDate: '',
      totalRequests: 0,
      pendingApprovals: 0,
      totalPendingAmount: 0,
      isLoading: false,
      imprestRequests: [],

      // For pagination
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,

      // For modal
      modalTitle: '',
      modalMessage: '',
      modalAction: '',
      selectedRequest: null,
      rejectionReason: '',

      // Toast notification
      toast: {
        show: false,
        message: '',
        type: 'success'
      }
    }
  },
  computed: {
    displayPages() {
      // Logic to display a reasonable number of page links
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      const delta = 2; // Number of pages to show before and after current page

      let pages = [];

      if (totalPages <= 5) {
        // If 5 or fewer pages, show all
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Always include first page
        pages.push(1);

        // Calculate start and end page numbers
        let startPage = Math.max(2, currentPage - delta);
        let endPage = Math.min(totalPages - 1, currentPage + delta);

        // Add ellipsis if needed
        if (startPage > 2) {
          pages.push('...');
        }

        // Add pages in range
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        // Add ellipsis if needed
        if (endPage < totalPages - 1) {
          pages.push('...');
        }

        // Always include last page
        pages.push(totalPages);
      }

      return pages;
    }
  },
  mounted() {
    this.getImprestRequests();
  },
  watch: {
    search() {
      this.getImprestRequests()
    }
  },
  methods: {
    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value || 0);
    },
    formatDate(dateString) {
      return moment(dateString).format('DD MMM YYYY');
    },
    getStatusBadgeClass(status) {
      switch(status.toLowerCase()) {
        case 'pending':
          return 'badge bg-warning text-dark';
        case 'approved':
          return 'badge bg-success';
        case 'rejected':
          return 'badge bg-danger';
        default:
          return 'badge bg-secondary';
      }
    },
    approveRequest(request) {
      this.selectedRequest = request;
      this.modalTitle = 'Approve Imprest Request';
      this.modalMessage = `Are you sure you want to approve imprest request ${request.request_id}?`;
      this.modalAction = 'approve';

      // Open the modal using Bootstrap modal API
      const modal = new bootstrap.Modal(document.getElementById('confirmationModal'));
      modal.show();
    },
    rejectRequest(request) {
      this.selectedRequest = request;
      this.rejectionReason = '';
      this.modalTitle = 'Reject Imprest Request';
      this.modalMessage = `Please provide a reason for rejecting imprest request ${request.request_id}:`;
      this.modalAction = 'reject';

      // Open the modal using Bootstrap modal API
      const modal = new bootstrap.Modal(document.getElementById('confirmationModal'));
      modal.show();
    },
    confirmAction() {
      if (this.modalAction === 'approve') {
        this.confirmApproval();
      } else {
        this.confirmRejection();
      }

      // Close modal
      const modalElement = document.getElementById('confirmationModal');
      const modal = bootstrap.Modal.getInstance(modalElement);
      modal.hide();
    },
    confirmApproval() {
      const data = new FormData();
      data.append("function", "approveImprestRequest");
      data.append("requestId", this.selectedRequest.request_id);

      this.isLoading = true;
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.selectedRequest.status = 'Approved';
              this.pendingApprovals--;
              this.showToast('Imprest request approved successfully', 'success');
            } else {
              this.showToast(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showToast(e.message, 'error');
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    confirmRejection() {
      if (!this.rejectionReason.trim()) {
        this.showToast('Please provide a reason for rejection', 'warning');
        return;
      }

      const data = new FormData();
      data.append("function", "rejectImprestRequest");
      data.append("requestId", this.selectedRequest.request_id);
      data.append("reason", this.rejectionReason);

      this.isLoading = true;
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.selectedRequest.status = 'Rejected';
              this.pendingApprovals--;
              this.showToast('Imprest request rejected successfully', 'success');
            } else {
              this.showToast(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showToast(e.message, 'error');
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getImprestRequests() {
      this.isLoading = true;
      const data = new FormData();
      data.append("function", "getImprestRequests");
      data.append("search", this.search);
      data.append("startDate", this.startDate);
      data.append("endDate", this.endDate);
      data.append("page", this.currentPage);
      data.append("perPage", this.itemsPerPage);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.imprestRequests = res.data.data.imprestRequests;
              this.totalRequests = res.data.data.metrics.totalRequests;
              this.pendingApprovals = res.data.data.metrics.pendingApprovals;
              this.totalPendingAmount = res.data.data.metrics.totalAmount;

              // Calculate total pages
              this.totalPages = Math.ceil(this.totalRequests / this.itemsPerPage);
            } else {
              this.showToast(res.data.message, 'error');
            }
          })
          .catch((e) => {
            this.showToast(e.message, 'error');
          })
          .finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500); // Add a slight delay to make loading state visible
          });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getImprestRequests();
      }
    },
    showToast(message, type = 'success') {
      // This method would show a toast notification
      // Instead of using alert, we'd set up a toast system
      // For now, we'll still use alert but could be enhanced later
      alert(message);
    }
  }
}
</script>

<style>
/* Add skeleton loader styles */
.skeleton-loader .skeleton-line {
  height: 20px;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Enhance table styles */
.table th {
  font-weight: 600;
  background-color: #f8f9fa;
}

.table td {
  vertical-align: middle;
}

/* Toast notification styles */
.custom-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  min-width: 300px;
}

/* Improve responsiveness */
@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    align-items: start !important;
  }

  .date-filter {
    width: 100%;
    margin-top: 1rem;
  }

  .search-box {
    width: 100%;
  }
}
</style>